<template>
  <div class="d-flex align-items-center">
    <b class="mr-1">Last Portal Login:</b>
    <span v-if="customer.last_login_at">{{
      shortDate(customer.last_login_at)
    }}</span>
    <span v-else>Not Available</span>
  </div>
</template>

<script>
export default {
  props: {
    customer: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.badge-divider {
  border-bottom: 1px solid var(--gray-border-color);
  width: 100%;
  margin: 2px 0;
}
</style>
